module.exports = __webpack_public_path__ + "img/zwy_JP.fb61908b.jpg";